import {
  AutoComplete,
  Button,
  Checkbox,
  Divider,
  Empty,
  Form,
  Input,
  InputNumber,
  message,
  Modal,
  Select,
  Tooltip,
  Typography,
  Upload,
  UploadProps,
  Spin,
  Alert,
  Badge,
  Dropdown,
  Table,
  Tag,
  Avatar,
  Popover,
} from "antd";
import { GrConnect } from "react-icons/gr";
import { useSearchParams } from "react-router-dom";

import { RcFile } from "antd/es/upload";
import { IconDocx, IconPdf } from "assets/icons/onboarding";
import PageTitle from "components/PageTitle";
import DashboardLayout from "layout/DashboardLayout";
import { Fragment, ReactElement, useState, useCallback, useEffect, useMemo } from "react";
import {
  TbFileText,
  TbInfoCircle,
  TbMinus,
  TbPlus,
  TbTrash,
  TbUsers,
  TbAlertCircle,
  TbCheck,
  TbExternalLink,
  TbChevronLeft,
  TbChevronRight,
  TbDotsVertical,
  TbEdit,
  TbLoader2,
  TbPlugConnected,
  TbRefresh,
  TbTax,
  TbTransactionDollar,
  TbUpload,
  TbReload,
  TbArrowsExchange,
  TbX,
} from "react-icons/tb";
import { MAX_FILE_UPLOAD_SIZE, stateNames } from "utils/constants";
import { formatDate, formatMoney, fuzzyMatch, humanFileSize, toTitleCase } from "utils/functions";
import { ApiService } from "api/api.service";
import { useNavigate } from "react-router-dom";
import { ItemType } from "antd/es/menu/interface";
import TextNumeric from "components/TextNumeric";
import { CreditorMatchSync, FREQUENCY_TYPES, LoanSchemaDto, OCR_STATUS } from "dtos/loan.dto";
import { WalletTypes } from "dtos/wallet.dto";
import {
  ViewFileLink,
  ViewFileBanks,
  CreditorModal,
  UploadLoanModal,
  UploadLoanModalProps,
  UploadLawSuitsModal,
} from "pages/ApplicationItem/ApplicationItem.components";
import { queryClient } from "utils/queryClient";
import { T_Populate } from "types/_utils.types";
import { FileSchemaDto } from "dtos/file.dto";
import dayjs from "dayjs";
import { get } from "http";
import { hasAnyValue } from "components/CustomStrategy/functions";
import OnboardingLoader from "pages/Onboarding/components/OnboardingLoader";
import StrategyConfigModal from "components/CreateAppplication/StrategyConfigModal";
import { record } from "zod";
import { LoanFrequencyMultiplier } from "components/Application/constants";
import { useWatch } from "antd/es/form/Form";
import { LoanFilesDrawer } from "components/LoanFilesDrawer";
import { BankFetchMethod } from "dtos/application.dto";
type ApplicationType = "standard" | "percentage";
const extensionIcons: Record<string, ReactElement> = {
  docx: <IconDocx />,
  pdf: <IconPdf />,
};

const CreateApplication = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const [strategyModalOpen, setStrategyModalOpen] = useState(false);
  const [newPartnerCreditorName, setNewPartnerCreditorName] = useState("");
  const stopLoader = (searchParams.get("stopLoading") ?? "true") === "true";
  console.log({ stopLoader });

  const appKey = searchParams.get("appkey");
  const stepFromParams = searchParams.get("step");
  const mode = searchParams.get("mode") as unknown as ApplicationType;
  const phoneFromParams = searchParams.get("phone");
  const emailFromParams = searchParams.get("email");
  const nameFromParams = searchParams.get("name");

  const [linkCreditorForm] = Form.useForm();

  const autoCompleteOption: { label: string; value: string }[] = stateNames.map((state) => {
    return { label: state, value: state };
  });
  const [selectedLoan, setSelectedLoan] = useState<
    | T_Populate<
        LoanSchemaDto,
        {
          attachments: FileSchemaDto[];
        }
      >
    | undefined
  >();
  // console.log({ selectedBank });
  const [hasDetails, setHasDetails] = useState<boolean | null>(null);
  const [openLinkCreditor, setOpenLinkCreditor] = useState(false);
  const [fetchingLoanId, setFetchingLoanId] = useState<string | null>(null);
  const [openLoanDrawer, setOpenLoanDrawer] = useState(false);

  const [allLoanOcrCompleted, setAllLoanOcrCompleted] = useState(true);
  const [isLawSuitsUploadModalOpen, setIsLawSuitsUploadModalOpen] = useState(false);
  const [openCreditorModal, setOpenCreditorModal] = useState(false);
  const [fetchedAppKey, setFetchedAppKey] = useState<string | undefined>(undefined);
  const [isCosignerModalOpen, setIsCosignerModalOpen] = useState(false);
  const [editingLoanId, setEditingLoanId] = useState<string | null>(null);
  const [isLoanUploadModalOpen, setIsLoanUploadModalOpen] = useState(false);
  const [uploadType, setUploadType] = useState<UploadLoanModalProps["uploadType"]>("loan");
  const [editingField, setEditingField] = useState<
    "funded_amount" | "payback_amount" | "due_amount" | "receivables" | null
  >(null);
  const [editValue, setEditValue] = useState<number | null>(null);
  const [step, setStep] = useState(stepFromParams ? Number(stepFromParams) : 1);
  const navigate = useNavigate();
  const [options, setOptions] = useState<{ label: string; value: string }[] | undefined>(autoCompleteOption);
  const [fileList, setFileList] = useState<RcFile[]>([]);
  const [bankFileList, setBankFileList] = useState<RcFile[]>([]);
  const [form] = Form.useForm();
  const [basicInfo] = Form.useForm();
  const createApplication = ApiService.upstream.useCreateNewApplication();
  const editUpstreamLoan = ApiService.upstream.useEditLoan();
  const syncBalance = ApiService.upstream.useSyncBalance();
  const linkCreditor = ApiService.creditor.useLinkCreditor();
  const editMetaInfo = ApiService.upstream.useEditMetaInfo();
  const syncFinancialInfo = ApiService.upstream.useSyncFinancialSummary();
  const [isConnectWithPlaidClicked, setConnectWithPlaid] = useState(false);
  const getAllOrgRes = ApiService.organisation.useGetPaginated({ page: 1, limit: 20 });
  const getAllOrgData = getAllOrgRes.data?.result.data ?? [];
  const [newCreditorName, setNewCreditorName] = useState("");
  const [emailValidationStatus, setEmailValidationStatus] = useState<{
    email: string;
    isChecking: boolean;
    isValid: boolean | null;
    message: string;
    appKey: string;
  }>({ email: "", isChecking: false, isValid: null, message: "", appKey: "" });
  const editLoan = ApiService.upstream.useEditLoan();
  const addCreditor = ApiService.creditor.useCreateCreditor();
  const deleteLoan = ApiService.upstream.useDeleteLoans();
  const [phoneValidationStatus, setPhoneValidationStatus] = useState<{
    phone: string;
    isChecking: boolean;
    isValid: boolean | null;
    message: string;
    appKey: string;
  }>({
    phone: "",
    isChecking: false,
    isValid: null,
    message: "",
    appKey: "",
  });
  const validateEmail = ApiService.upstream.useValidateMail();
  const validatePhone = ApiService.upstream.useValidatePhone();
  const fullApplication = ApiService.application.useGetByAppKey(fetchedAppKey);
  const getclearApplication = fullApplication.data?.data.application;
  const allCreditors = ApiService.creditor.useGetAllCreditorNames();
  const allCreditorsData = allCreditors.data?.result ?? [];
  console.log({ fetchingLoanId, editingLoanId, selectedLoan });
  const creditorNames = useMemo(
    () =>
      allCreditorsData.map((c) => {
        return {
          name: c.name,
          id: c._id,
          isPartner: c.isPartner,
        };
      }),
    [allCreditorsData],
  );
  console.log({ hasDetails });

  // ✅ Effect 1: Poll for OCR completion (only when step === 2 and loans exist)

  const findCurrentWeeklyPaymnet = () => {
    //if the loan frequency is daily the multiply it with 5 and if it is weekly just keeps as it is
    const loans = fullApplication?.data?.data?.application?.loans ?? [];
    const currentWeeklyPayment = loans.reduce((acc, loan) => {
      if (loan.frequency === "daily") {
        return acc + (loan.payments ?? 0) * 5;
      }
      if (loan.frequency === "weekly") {
        return acc + (loan.payments ?? 0);
      }
      return acc;
    }, 0);
    return currentWeeklyPayment;
  };
  const findCurrentDebt = () => {
    const loans = fullApplication?.data?.data?.application?.loans ?? [];
    const currentWeeklyPayment = loans.reduce((acc, loan) => {
      return acc + (loan.due_amount ?? 0);
    }, 0);
    return currentWeeklyPayment;
  };

  useEffect(() => {
    if (step !== 2) return; // Only run on step 2
    if (!fullApplication?.data?.data?.application?.loans) {
      return;
    }

    const loans = fullApplication.data.data.application.loans;

    let processingLoans = loans.filter((loan) => {
      const diff = dayjs().diff(dayjs(loan.createdAt), "minute");
      return (loan.ocrState === OCR_STATUS.PENDING || loan.ocrState === OCR_STATUS.RUNNING) && diff >= 0 && diff <= 15;
    });

    if (processingLoans.length === 0) {
      setAllLoanOcrCompleted(true);
      return;
    }
    setAllLoanOcrCompleted(false);

    const intervalId = setInterval(async () => {
      try {
        const refetchResult = await fullApplication.refetch();

        if (!refetchResult.data?.data?.application?.loans) {
          return;
        }

        const updatedLoans = refetchResult.data.data.application.loans;

        processingLoans = updatedLoans.filter((loan) => {
          const diff = dayjs().diff(dayjs(loan.createdAt), "minute");
          return (
            (loan.ocrState === OCR_STATUS.PENDING || loan.ocrState === OCR_STATUS.RUNNING) && diff >= 0 && diff <= 15
          );
        });

        if (processingLoans.length === 0) {
          setAllLoanOcrCompleted(true);
          clearInterval(intervalId);
          message.success("All loan processing have been completed!");
        }
      } catch (error) {
        setAllLoanOcrCompleted(true);
        console.error("Error polling OCR status:", error);
        clearInterval(intervalId);
      }
    }, 5000);

    return () => {
      clearInterval(intervalId);
    };
  }, [step, appKey, fullApplication]); // Only depend on step and appKey

  // ✅ Effect 2: Poll for client/business details (only when step === 3 and details not found yet)
  useEffect(() => {
    if (step !== 3) return; // Only run on step 3
    if (hasDetails !== null) return; // Don't re-run if we already have a definitive answer
    if (!fullApplication?.data?.data?.application) return;
    if (stopLoader) {
      form.setFieldsValue({
        business_info: {
          phone: phoneFromParams ?? undefined,
          // email: "anv@df.cgd",
          email: emailFromParams ?? undefined,
        },
        summary: {
          current_debt: findCurrentDebt(),
          weekly_payments: findCurrentWeeklyPaymnet(),
        },
      });
      setHasDetails(true);
      return;
    }

    const MAX_WAIT_TIME = 2 * 60 * 1000;
    const POLL_INTERVAL = 5000;
    const startTime = Date.now();

    const checkIfDataExists = (application: Record<string, unknown>) => {
      const client = application?.client_details;
      const business = application?.business_info;
      return (client ? hasAnyValue(client) : false) || (business ? hasAnyValue(business) : false);
    };

    const initialApp = fullApplication.data.data.application;
    console.log({ initialCheck: initialApp });

    if (checkIfDataExists(initialApp)) {
      console.log({ emailFromParams, phoneFromParams });
      console.log("Initial check - details found");
      form.setFieldsValue({
        client_details: {
          ...initialApp.client_details,
          ssn: initialApp?.client_details?.ssn ? initialApp?.client_details?.ssn?.split("-").join("") : "",
        },
        business_info: {
          ...initialApp.business_info,
          phone: initialApp?.business_info?.phone ? initialApp?.business_info?.phone : phoneFromParams,
          // email: "anv@df.cgd",
          email: initialApp?.business_info?.email ? initialApp?.business_info?.email : emailFromParams,
          ein_number: initialApp?.business_info?.ein_number
            ? initialApp?.business_info?.ein_number?.split("-").join("")
            : "",
        },
        summary: {
          current_debt: findCurrentDebt(),
          weekly_payments: findCurrentWeeklyPaymnet(),
        },
      });
      setHasDetails(true);
      return;
    }

    // Only start polling if initial check found nothing
    const intervalId = setInterval(async () => {
      try {
        const elapsed = Date.now() - startTime;

        if (elapsed > MAX_WAIT_TIME) {
          clearInterval(intervalId);
          setHasDetails(false);
          console.log("Stopped polling: max wait time exceeded");
          return;
        }

        const refetchResult = await fullApplication.refetch();
        const updatedApp = refetchResult.data?.data?.application;

        if (!updatedApp) return;

        if (checkIfDataExists(updatedApp)) {
          form.setFieldsValue({
            client_details: {
              ...updatedApp.client_details,
              ssn: initialApp?.client_details?.ssn ? initialApp?.client_details?.ssn?.split("-").join("") : "",
            },
            business_info: {
              ...updatedApp.business_info,
              phone: updatedApp?.business_info?.phone ? updatedApp?.business_info?.phone : phoneFromParams,
              email: updatedApp?.business_info?.email ? updatedApp?.business_info?.email : emailFromParams,
              ein_number: updatedApp?.business_info?.ein_number
                ? updatedApp?.business_info?.ein_number?.split("-").join("")
                : "",
            },
            summary: {
              current_debt: findCurrentDebt(),
              weekly_payments: findCurrentWeeklyPaymnet(),
            },
          });
          setHasDetails(true);
          clearInterval(intervalId);
          message.success("Client/Business details found!");
        }
      } catch (error) {
        clearInterval(intervalId);
        console.error("Error polling details:", error);
        setHasDetails(false);
      }
    }, POLL_INTERVAL);

    return () => clearInterval(intervalId);
  }, [step, hasDetails, fullApplication, form]);

  useEffect(() => {
    if (appKey) {
      setFetchedAppKey(appKey);
    }
  }, [appKey]);

  const handleEmailValidation = useCallback(
    async (email: string) => {
      if (!email || email.trim() === "") {
        setEmailValidationStatus({ email: "", isChecking: false, isValid: null, message: "", appKey: "" });
        return;
      }

      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailRegex.test(email)) {
        setEmailValidationStatus({
          email,
          isChecking: false,
          isValid: false,
          message: "Invalid email format",
          appKey: "",
        });
        return;
      }

      setEmailValidationStatus({
        email,
        isChecking: true,
        isValid: null,
        message: "Validating email...",
        appKey: "",
      });

      try {
        const res = await validateEmail.mutateAsync({ email });

        if (res.result.userExists) {
          setEmailValidationStatus({
            email,
            isChecking: false,
            isValid: true,
            message: "Email is valid and available",
            appKey: res.result.lastAppkey ?? "",
          });
        } else {
          setEmailValidationStatus({
            email,
            isChecking: false,
            isValid: false,
            message: "Email Alreday Found in Get Clear",
            appKey: "",
          });
        }
      } catch (error) {
        setEmailValidationStatus({
          email,
          isChecking: false,
          isValid: false,
          message: "Error validating email. Please try again.",
          appKey: "",
        });
        console.error("Email validation error:", error);
      }
    },
    [validateEmail],
  );
  const handlePhoneValidation = useCallback(
    async (phone: string) => {
      // remove formatting -> keep only numbers
      const onlyNumbers = phone?.replace(/\D/g, "");

      if (!onlyNumbers || onlyNumbers.trim() === "") {
        setPhoneValidationStatus({
          phone: "",
          isChecking: false,
          isValid: null,
          message: "",
          appKey: "",
        });
        return;
      }

      // check 10 digit phone
      const phoneRegex = /^\d{10}$/;

      if (!phoneRegex.test(onlyNumbers)) {
        setPhoneValidationStatus({
          phone: onlyNumbers,
          isChecking: false,
          isValid: false,
          message: "Invalid phone number",
          appKey: "",
        });
        return;
      }

      setPhoneValidationStatus({
        phone: onlyNumbers,
        isChecking: true,
        isValid: null,
        message: "Validating phone...",
        appKey: "",
      });

      try {
        const res = await validatePhone.mutateAsync({
          phone: onlyNumbers,
        });

        if (res.result.userExists) {
          setPhoneValidationStatus({
            phone: onlyNumbers,
            isChecking: false,
            isValid: true,
            message: "Phone is valid and available",
            appKey: res.result.lastAppkey ?? "",
          });
        } else {
          setPhoneValidationStatus({
            phone: onlyNumbers,
            isChecking: false,
            isValid: false,
            message: "Phone already found in Get Clear",
            appKey: "",
          });
        }
      } catch (error) {
        setPhoneValidationStatus({
          phone: onlyNumbers,
          isChecking: false,
          isValid: false,
          message: "Error validating phone. Please try again.",
          appKey: "",
        });

        console.error("Phone validation error:", error);
      }
    },
    [validatePhone],
  );

  const validateAllLoanFields = (): boolean => {
    const loans = getclearApplication?.loans ?? [];

    if (loans.length === 0) {
      message.error("Please add at least one loan");
      return false;
    }

    for (const loan of loans) {
      if (!loan.funded_amount || loan.funded_amount <= 0) {
        message.error(`Please fill the Funded Amount for loan: ${loan.creditor_name || "Unknown"}`);
        return false;
      }

      if (!loan.payback_amount || loan.payback_amount <= 0) {
        message.error(`Please fill the Payback Amount for loan: ${loan.creditor_name || "Unknown"}`);
        return false;
      }

      if (!loan.due_amount && loan.due_amount !== 0) {
        message.error(`Please fill the Balance Amount for loan: ${loan.creditor_name || "Unknown"}`);
        return false;
      }

      if (!loan.payments || loan.payments <= 0) {
        message.error(`Please fill the Installation Payment for loan: ${loan.creditor_name || "Unknown"}`);
        return false;
      }
    }

    return true;
  };

  const handleStartEdit = (
    loanId: string,
    field: "funded_amount" | "payback_amount" | "due_amount" | "receivables",
    value: number,
  ) => {
    setEditingLoanId(loanId);
    setEditingField(field);
    setEditValue(value);
  };
  // Handler for saving edited value
  const handleSaveEdit = (loan: T_Populate<LoanSchemaDto, { attachments: FileSchemaDto[] }>) => {
    if (!editingLoanId || !editingField || editValue === null) return;

    const DERIVED_LOAN_FIELDS = new Set(["breakeven_amount", "balance_to_totaldebt_percentage", "net_purchase_price"]);
    const NPP_INPUT_FIELDS = new Set(["funded_amount", "origination_fees", "additional_fees_deductions"]);

    const updatedLoan = {
      ...loan,
      [editingField]: editValue,
      attachments: loan?.attachments?.map((el) => el._id),
      manual_overrides:
        DERIVED_LOAN_FIELDS.has(editingField) || NPP_INPUT_FIELDS.has(editingField) ? [editingField] : [],
      autocalculate: true,
    };
    setFetchingLoanId(editingLoanId);
    // setSelectedLoan(loan);

    editLoan.mutate(
      { appkey: appKey!, loan: updatedLoan, source: "create-application" },
      {
        onSuccess: () => {
          message.success("Loan updated successfully!");
          setEditingLoanId(null);
          setEditingField(null);
          setEditValue(null);
          queryClient.invalidateQueries({ queryKey: ["application", appKey] });
        },
        onError: () => {
          message.error("Failed to update loan");
        },
      },
    );
  };

  const props: UploadProps = {
    name: "files",
    accept: ".pdf",
    multiple: true,
    beforeUpload: (file) => {
      const isLtMaxSize = file.size / 1024 / 1024 < MAX_FILE_UPLOAD_SIZE;
      const isSameFile = fileList.find((el) => {
        return el.name === file.name && el.size === file.size;
      });
      if (!isLtMaxSize) {
        message.error(`File must smaller than ${MAX_FILE_UPLOAD_SIZE}MB!`);
      } else if (isSameFile) {
        message.error("File with same name and same size already exists. Please rename the file and re-upload");
      } else {
        setFileList((prev) => [...prev, file]);
      }

      return Upload.LIST_IGNORE;
    },
  };
  const bankProps: UploadProps = {
    name: "files",
    accept: ".pdf",
    multiple: true,
    beforeUpload: (file) => {
      const isLtMaxSize = file.size / 1024 / 1024 < MAX_FILE_UPLOAD_SIZE;
      const isSameFile = bankFileList.find((el) => {
        return el.name === file.name && el.size === file.size;
      });
      if (!isLtMaxSize) {
        message.error(`File must smaller than ${MAX_FILE_UPLOAD_SIZE}MB!`);
      } else if (isSameFile) {
        message.error("File with same name and same size already exists. Please rename the file and re-upload");
      } else {
        setBankFileList((prev) => [...prev, file]);
      }

      return Upload.LIST_IGNORE;
    },
  };
  const handleSubmit = async () => {
    const basicInfoDetails = await basicInfo.validateFields();
    const values = await form.validateFields();
    const isPriorApplication = ((basicInfoDetails.isPriorApplication as string) ?? "no") === "yes";

    const clientDetails = {
      ...values.client_details,
      name: basicInfoDetails.name,
      email: basicInfoDetails.email,
      phone: basicInfoDetails.phone,
    };
    setSearchParams((prev) => {
      prev.set("email", basicInfoDetails.email);
      if (basicInfoDetails.phone) {
        prev.set("phone", basicInfoDetails.phone);
      }
      return prev;
    });
    const formData = new FormData();
    formData.append("basic_information", JSON.stringify(basicInfoDetails));
    formData.append("business_info", JSON.stringify(values.business_info));
    formData.append("client_details", JSON.stringify(clientDetails));
    formData.append("selected_bank", JSON.stringify(values.selected_bank));
    formData.append("summary", JSON.stringify(values.summary));
    formData.append("organisation", basicInfoDetails.organisation);
    formData.append("isPriorApplication", String(isPriorApplication));
    formData.append("mode", mode ?? "standard");
    if (isConnectWithPlaidClicked) {
      formData.append("bank_fetch_via", BankFetchMethod.PLAID);
    }
    fileList.forEach((file) => {
      formData.append("loans", file);
    });
    bankFileList.forEach((file) => {
      formData.append("banks", file);
    });
    console.log({ formData });
    // send formData to backend
    createApplication.mutate(
      { formData },
      {
        onSuccess: (data) => {
          // navigate(`/dashboard/application/${data.result.appkey}`);
          setSearchParams((prev) => {
            prev.set("appkey", data.result.appkey);
            return prev;
          });
          setSearchParams((prev) => {
            prev.set("step", "2");
            return prev;
          });
          setStep((prev) => prev + 1);
        },
      },
    );
  };
  const handleLoanFrequencyChange = ({
    newFrequency,
    prevFrequency,
    record,
  }: {
    prevFrequency: FREQUENCY_TYPES;
    newFrequency: FREQUENCY_TYPES;
    record: T_Populate<LoanSchemaDto, { attachments: FileSchemaDto[] }>;
  }) => {
    const payments = record?.payments ?? 0;
    const dailyAmount = payments / LoanFrequencyMultiplier[prevFrequency];
    const newPaybackAmount = dailyAmount * LoanFrequencyMultiplier[newFrequency];

    const updatedLoan = {
      ...record,
      frequency: newFrequency,
      payments: newPaybackAmount,
    };

    editUpstreamLoan.mutate(
      { appkey: appKey!, loan: updatedLoan as any, source: "create-application" },
      {
        onSuccess: () => {
          message.success("Loan frequency updated successfully!");
          queryClient.invalidateQueries({ queryKey: ["application", appKey] });
        },
      },
    );
  };
  const isOcrProcessing = (record: T_Populate<LoanSchemaDto, { attachments: FileSchemaDto[] }>) => {
    switch (record.ocrState) {
      case OCR_STATUS.PENDING:
      case OCR_STATUS.RUNNING: {
        const diff = dayjs().diff(dayjs(record.createdAt), "minute");
        return diff >= 0 && diff <= 15;
      }

      default:
        return false;
    }
  };
  const ACTIVE_OCR_STATES = new Set<OCR_STATUS>([OCR_STATUS.PENDING, OCR_STATUS.RUNNING]);

  const isOcrFailed = (record: T_Populate<LoanSchemaDto, { attachments: FileSchemaDto[] }>) => {
    if (!record.ocrState) {
      return false;
    }

    if (ACTIVE_OCR_STATES.has(record.ocrState)) {
      return false;
    }

    return record.ocrState === OCR_STATUS.FAILED;
  };

  const isPriorApplication = (useWatch(["isPriorApplication"], basicInfo) ?? "no") === "yes";
  console.log({ isPriorApplication });

  return (
    <DashboardLayout
      headerRight={
        <div className="flex items-center gap-2">
          {step === 3 && (
            <div>
              <Button type="primary" ghost onClick={() => setOpenLoanDrawer(true)}>
                View Loan Files
              </Button>
              <LoanFilesDrawer appkey={appKey!} open={openLoanDrawer} onClose={() => setOpenLoanDrawer(false)} />
            </div>
          )}
        </div>
      }
    >
      <PageTitle
        title={"Create Application"}
        pageTitle={[{ title: "Applications", link: "/dashboard/applications" }, { title: "Create Application" }]}
      />
      {step === 1 && (
        <>
          <Form form={basicInfo} layout="vertical">
            <div className="flex flex-col gap-8  mx-auto pt-2  mt-8">
              <div className="bg-white  rounded-xl overflow-auto">
                <div className="flex justify-between items-center px-6 py-2  ">
                  <div className="flex items-center gap-2">
                    {" "}
                    <Typography.Title level={5} className="!m-0">
                      Basic Information
                    </Typography.Title>
                    <Tooltip title="An account will be created for the client with the provided email on customer portal.">
                      <TbInfoCircle size={20} />
                    </Tooltip>
                  </div>
                </div>
                <div className="px-5 py-2">
                  <div className="grid grid-cols-12 gap-2">
                    <div className="col-span-6">
                      <Form.Item name={"name"} label="Full Name" rules={[{ required: true }]}>
                        <Input />
                      </Form.Item>
                    </div>
                    <div className="col-span-6">
                      <Form.Item name={["email"]} label="Email" rules={[{ required: true, type: "email" }]}>
                        <Input
                          onBlur={(e) => {
                            handleEmailValidation(e.target.value);
                          }}
                          suffix={
                            emailValidationStatus.email &&
                            (emailValidationStatus.isChecking ? (
                              <Spin size="small" />
                            ) : !emailValidationStatus.appKey ? null : (
                              <TbAlertCircle style={{ color: "red", fontSize: 16 }} />
                            ))
                          }
                        />
                      </Form.Item>
                      {emailValidationStatus.appKey && (
                        <div
                          style={{
                            marginTop: "-12px",
                            marginBottom: "8px",
                            fontSize: "12px",
                            color: emailValidationStatus.isValid ? "red" : "red",
                          }}
                        >
                          <div>
                            <Typography.Text style={{ color: emailValidationStatus.appKey ? "red" : "red" }}>
                              {"An application found with this email. Do you want to continue?"}
                            </Typography.Text>
                            <Button
                              type="text"
                              size="small"
                              onClick={() => window.open(`/dashboard/application/${emailValidationStatus.appKey}`)}
                              icon={<TbExternalLink />}
                            ></Button>
                          </div>
                        </div>
                      )}
                      {/* {emailValidationStatus.appKey && (
                    <div
                      style={{
                        marginTop: "-12px",
                        marginBottom: "8px",
                        fontSize: "12px",
                        color: emailValidationStatus.isValid ? "green" : "red",
                      }}
                    >
                     
                    </div>
                  )} */}
                    </div>
                  </div>
                  <div className="grid grid-cols-12 gap-2">
                    <div className="col-span-4">
                      <Form.Item name={"phone"} label="Phone">
                        <InputNumber<string>
                          suffix={
                            phoneValidationStatus.phone &&
                            (phoneValidationStatus.isChecking ? (
                              <Spin size="small" />
                            ) : !phoneValidationStatus.appKey ? null : (
                              <TbAlertCircle style={{ color: "red", fontSize: 16 }} />
                            ))
                          }
                          type="tel"
                          onBlur={(e) => {
                            handlePhoneValidation(e.target.value);
                          }}
                          minLength={14}
                          maxLength={14}
                          style={{ width: "100%" }}
                          formatter={(value) => {
                            if (!value) return "";
                            const onlyNumbers = `${value}`.replace(/\D/g, "");
                            const formatted = onlyNumbers.replace(
                              /^(\d{0,3})(\d{0,3})(\d{0,4})$/,
                              (match, p1, p2, p3) => `${p1 ? `(${p1}) ` : ""}${p2 ? `${p2}` : ""}${p3 ? `-${p3}` : ""}`,
                            );
                            return formatted.trim();
                          }}
                          parser={(value) => value?.replace(/\D/g, "") as unknown as string}
                          controls={false}
                        />
                      </Form.Item>
                      {phoneValidationStatus.appKey && (
                        <div
                          style={{
                            marginTop: "-12px",
                            marginBottom: "8px",
                            fontSize: "12px",
                            color: phoneValidationStatus.isValid ? "red" : "red",
                          }}
                        >
                          <div>
                            <Typography.Text style={{ color: phoneValidationStatus.appKey ? "red" : "red" }}>
                              {"An application found with this phone.  Do you want to continue? "}
                            </Typography.Text>
                            <Button
                              type="text"
                              size="small"
                              onClick={() => window.open(`/dashboard/application/${phoneValidationStatus.appKey}`)}
                              icon={<TbExternalLink />}
                            ></Button>
                          </div>
                        </div>
                      )}
                    </div>
                    <div className="col-span-4">
                      <Form.Item label="Select Organisation" name={"organisation"} rules={[{ required: true }]}>
                        <Select
                          style={{ width: "100%" }}
                          showSearch
                          placeholder="Select organisation"
                          filterOption={(input, option) =>
                            option?.searchLabel?.toLowerCase().includes(input.toLowerCase()) ?? false
                          }
                          options={getAllOrgData.map((profile) => ({
                            value: profile._id,
                            label: (
                              <div className="flex items-center gap-3">
                                <Avatar className="uppercase font-semibold" src={profile.meta?.favicon}>
                                  {profile.name.charAt(0).toUpperCase()}
                                </Avatar>

                                <Typography.Text className="text-xs">{profile.name}</Typography.Text>
                              </div>
                            ),
                            searchLabel: profile.name, // 👈 custom field
                          }))}
                        />
                      </Form.Item>
                    </div>
                    <div className="col-span-4">
                      <Form.Item label="Prior Application" name={"isPriorApplication"}>
                        <Select
                          style={{ width: "100%" }}
                          showSearch
                          defaultValue={"No"}
                          // filterOption={(input, option) =>
                          //   option?.searchLabel?.toLowerCase().includes(input.toLowerCase()) ?? false
                          // }
                          options={[
                            {
                              label: "Yes",
                              value: "yes",
                            },
                            {
                              label: "No",
                              value: "no",
                            },
                          ]}
                        />
                      </Form.Item>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </Form>
          {isPriorApplication && (
            <div className="px-4 mb-4">
              <Alert type="info" message="Once marked as a prior application, the organization cannot be modified." />
            </div>
          )}
          <div className="">
            <div className="flex  w-full gap-4">
              <div className="flex border-[0] border-r border-solid border-gray-300 w-full flex-col gap-4  mx-auto p-5">
                <Typography.Title style={{ margin: 0 }} level={5}>
                  Upload Loan Documents (Optional)
                </Typography.Title>
                {
                  <div className="flex items-center justify-between">
                    <Typography.Title type="secondary" className="!mb-0 !text-sm" level={5}>
                      Uploaded Loans ({fileList.length})
                    </Typography.Title>
                    <Upload {...props}>
                      <Button icon={<TbFileText />} variant="filled" color="primary" className="border-purple-300">
                        {fileList.length === 0 ? "Upload Files" : `Upload More Files`}
                      </Button>
                    </Upload>
                  </div>
                }

                <div className="flex flex-col gap-3">
                  {fileList.map((file) => {
                    const x = file.name?.split(".");
                    const extension = x[x?.length - 1];
                    const fileName = file?.name;

                    return (
                      <div
                        key={file.uid}
                        className="bg-white rounded-xl border border-solid border-gray-300 flex items-center gap-3 p-3"
                      >
                        <div className="text-3xl">{extensionIcons[extension]}</div>
                        <div className="flex gap-3 justify-between w-full">
                          <div className="">
                            <Typography.Title level={5} className="!mb-1 !text-sm">
                              {fileName}
                            </Typography.Title>
                            <Typography.Text type="secondary">{humanFileSize(file?.size ?? 0)}</Typography.Text>
                          </div>
                        </div>
                        <Button
                          variant="text"
                          color="danger"
                          danger
                          icon={<TbTrash />}
                          onClick={() => {
                            setFileList((prev) => {
                              return prev.filter((el) => el.uid !== file.uid);
                            });
                          }}
                        />
                      </div>
                    );
                  })}
                </div>
              </div>

              <div className="flex w-full flex-col gap-4  mx-auto p-5">
                <div className="flex items-center justify-between">
                  <Typography.Title style={{ margin: 0 }} level={5}>
                    Upload Bank (Optional)
                  </Typography.Title>
                </div>
                <Button
                  onClick={() => {
                    setConnectWithPlaid(!isConnectWithPlaidClicked);
                    setBankFileList([]);
                  }}
                  variant="filled"
                  color="primary"
                  className="border-purple-300"
                  icon={isConnectWithPlaidClicked ? <TbX /> : <GrConnect />}
                >
                  {isConnectWithPlaidClicked ? "Disconnect with Plaid" : `Connect with Plaid`}
                </Button>
                {!isConnectWithPlaidClicked && <Divider style={{ margin: 0 }}>Or</Divider>}
                {!isConnectWithPlaidClicked ? (
                  <div className="flex items-center justify-between">
                    <Typography.Title type="secondary" className="!mb-0 !text-sm" level={5}>
                      Uploaded Banks ({bankFileList.length})
                    </Typography.Title>
                    <Upload {...bankProps}>
                      <Button icon={<TbFileText />} variant="filled" color="primary" className="border-purple-300">
                        {bankFileList.length === 0 ? "Upload Files" : `Upload More Files`}
                      </Button>
                    </Upload>
                  </div>
                ) : (
                  <div className="w-full flex justify-center mt-4 ">
                    <Typography.Text type="secondary" className="!font-semibold">
                      Once you press Continue, you will be sent a link to connect with Plaid to the provided email.
                    </Typography.Text>
                  </div>
                )}

                <div className="flex flex-col gap-3">
                  {bankFileList.map((file) => {
                    const x = file.name?.split(".");
                    const extension = x[x?.length - 1];
                    const fileName = file?.name;

                    return (
                      <div
                        key={file.uid}
                        className="bg-white rounded-xl border border-solid border-gray-300 flex items-center gap-3 p-3"
                      >
                        <div className="text-3xl">{extensionIcons[extension]}</div>
                        <div className="flex gap-3 justify-between w-full">
                          <div className="">
                            <Typography.Title level={5} className="!mb-1 !text-sm">
                              {fileName}
                            </Typography.Title>
                            <Typography.Text type="secondary">{humanFileSize(file?.size ?? 0)}</Typography.Text>
                          </div>
                        </div>
                        <Button
                          variant="text"
                          color="danger"
                          danger
                          icon={<TbTrash />}
                          onClick={() => {
                            setBankFileList((prev) => {
                              return prev.filter((el) => el.uid !== file.uid);
                            });
                          }}
                        />
                      </div>
                    );
                  })}
                </div>
              </div>
            </div>
            <div className="fixed z-20 p-4 border-0  bottom-0 right-0 flex justify-center mt-4">
              <Button
                loading={createApplication.isPending}
                size="large"
                onClick={handleSubmit}
                iconPosition="end"
                icon={<TbChevronRight />}
                type="primary"
              >
                Continue
              </Button>
            </div>
          </div>
        </>
      )}
      {step === 2 &&
        (fullApplication.isPending ? (
          <OnboardingLoader />
        ) : (
          <div className="flex px-6 flex-col gap-6 mt-6">
            {getclearApplication?.loans?.some(
              (loan) =>
                loan.funded_amount == null ||
                loan.funded_date == null ||
                loan.payback_amount == null ||
                loan.due_amount == null,
            ) && (
              <Alert
                type="error"
                showIcon
                closable
                description="Critical: Some required loan information is missing. These fields are needed to provide insights and process the loan for further steps in the application."
                style={{ padding: "8px 12px" }}
              />
            )}
            <div className="border border-solid border-gray-200 rounded-lg">
              <div className="flex items-center justify-between mx-3 my-3">
                <Typography.Title level={5} className="">
                  Loans Details
                </Typography.Title>
                <div className="flex items-center gap-1">
                  <Button
                    onClick={() => {
                      setSelectedLoan(undefined);
                      setOpenCreditorModal(true);
                    }}
                    icon={<TbTax />}
                    size="small"
                    variant="outlined"
                    color="purple"
                  >
                    Add New Loan
                  </Button>
                  <Button
                    onClick={() => {
                      setIsLoanUploadModalOpen(true);
                      setUploadType("loan");
                    }}
                    icon={<TbUpload />}
                    size="small"
                    variant="outlined"
                    color="purple"
                  >
                    Upload New Loan
                  </Button>
                </div>
              </div>
              <Table
                rowKey={"_id"}
                onRow={(record) => ({
                  onClick: (e) => {
                    if (isOcrProcessing(record)) {
                      e.preventDefault();
                      e.stopPropagation();
                    }
                  },
                })}
                rowClassName={(record) =>
                  isOcrProcessing(record) ||
                  (fullApplication.isFetching && record._id === selectedLoan?._id) ||
                  (editLoan.isPending && record._id === fetchingLoanId) ||
                  (fullApplication.isFetching && record._id === fetchingLoanId)
                    ? "progress_loader"
                    : ""
                }
                columns={[
                  {
                    key: "creditor_name",
                    dataIndex: "creditor_name",
                    title: "Creditor Name",
                    render: (value: string, record) => {
                      const attachment = record.attachments?.[0];
                      const matchType = record?.creditor_match;
                      const tagConfig =
                        matchType === CreditorMatchSync.MATCHED
                          ? { label: "M", color: "green", tooltip: "Matched" }
                          : matchType === CreditorMatchSync.PROBABLE
                            ? { label: "P", color: "yellow", tooltip: "Probable match" }
                            : matchType === CreditorMatchSync.DRAFT
                              ? { label: "D", color: "red", tooltip: "Draft" }
                              : { label: "N", color: "default", tooltip: "Not linked" };
                      const isProcessing = isOcrProcessing(record);
                      const isFailed = isOcrFailed(record);
                      return (
                        <div className="flex items-center gap-2">
                          {isProcessing && (
                            <Tooltip title="OCR processing in progress... Auto-refreshing every 5 seconds">
                              <TbLoader2 className="h-4 w-4 animate-spin text-blue-500" aria-label="OCR processing" />
                            </Tooltip>
                          )}
                          <div className="flex flex-col items-start">
                            {attachment ? (
                              <ViewFileLink fileId={attachment._id} appKey={getclearApplication?.app_key as string}>
                                {value}
                              </ViewFileLink>
                            ) : (
                              <span>{value}</span>
                            )}
                            {isFailed && (
                              <div className="flex flex-col items-start">
                                <Typography.Text className="!text-xs" type="danger">
                                  OCR Failed.
                                </Typography.Text>

                                {record.ocr_remark && (
                                  <Popover
                                    trigger="click"
                                    placement="top"
                                    content={
                                      <div className="max-w-sm">
                                        {record.confidence_score != null && (
                                          <div className="mb-2 font-semibold">
                                            Confidence: {record.confidence_score}%
                                          </div>
                                        )}
                                        <Typography.Text className="!text-xs">{record.ocr_remark}</Typography.Text>
                                      </div>
                                    }
                                  >
                                    <Typography.Link className="!p-0 !text-[11px]" onClick={(e) => e.stopPropagation()}>
                                      Click here to learn why.
                                    </Typography.Link>
                                  </Popover>
                                )}
                              </div>
                            )}
                          </div>
                          <div className="flex gap-2 items-center">
                            <Tooltip title={tagConfig.tooltip}>
                              <Tag className="!m-0 w-fit px-2 py-0.5 text-xs font-semibold" color={tagConfig.color}>
                                {tagConfig.label}
                              </Tag>
                            </Tooltip>
                            {!isProcessing && record.due_amount === undefined && (
                              <Tooltip title="Balance amount should be provided. Please edit loan details.">
                                <span className="inline-flex items-center text-gray-400 hover:text-gray-600">
                                  <TbInfoCircle color="red" className="h-4 w-4" />
                                </span>
                              </Tooltip>
                            )}
                          </div>
                        </div>
                      );
                    },
                  },
                  {
                    key: "funded_amount",
                    dataIndex: "funded_amount",
                    title: "Funded Amount",
                    align: "end",
                    render: (val, record) => {
                      const isEditing = editingLoanId === record._id && editingField === "funded_amount";
                      return (
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "flex-end",
                            alignItems: "center",
                            gap: "8px",
                          }}
                        >
                          {isEditing ? (
                            <InputNumber
                              controls={false}
                              prefix="$"
                              value={editValue ?? val}
                              onChange={(value) => setEditValue(value)}
                              style={{ width: "140px" }}
                              formatter={(value) => {
                                const [start, end] = `${value}`.split(".") || [];
                                const v = `${start}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                                return `${end ? `${v}.${end}` : `${v}`}`;
                              }}
                              parser={(value) => value?.replace(/\$\s?|(,*)/g, "") as unknown as number}
                            />
                          ) : (
                            <TextNumeric>{formatMoney(val)}</TextNumeric>
                          )}
                          {!isEditing ? (
                            <TbEdit
                              onClick={() => handleStartEdit(record._id, "funded_amount", val)}
                              style={{ cursor: "pointer", flexShrink: 0 }}
                            />
                          ) : editValue !== val ? (
                            <TbCheck
                              onClick={() => handleSaveEdit(record)}
                              style={{ cursor: "pointer", flexShrink: 0, color: "green" }}
                            />
                          ) : null}
                        </div>
                      );
                    },
                  },
                  {
                    key: "payback_amount",
                    dataIndex: "payback_amount",
                    title: "Payback Amount",
                    align: "end",
                    render: (val, record) => {
                      const isEditing = editingLoanId === record._id && editingField === "payback_amount";
                      return (
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "flex-end",
                            alignItems: "center",
                            gap: "8px",
                          }}
                        >
                          {isEditing ? (
                            <InputNumber
                              controls={false}
                              prefix="$"
                              value={editValue ?? val}
                              onChange={(value) => setEditValue(value)}
                              style={{ width: "140px" }}
                              formatter={(value) => {
                                const [start, end] = `${value}`.split(".") || [];
                                const v = `${start}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                                return `${end ? `${v}.${end}` : `${v}`}`;
                              }}
                              parser={(value) => value?.replace(/\$\s?|(,*)/g, "") as unknown as number}
                            />
                          ) : (
                            <TextNumeric>{formatMoney(val)}</TextNumeric>
                          )}
                          {!isEditing ? (
                            <TbEdit
                              onClick={() => handleStartEdit(record._id, "payback_amount", val)}
                              style={{ cursor: "pointer", flexShrink: 0 }}
                            />
                          ) : editValue !== val ? (
                            <TbCheck
                              onClick={() => handleSaveEdit(record)}
                              style={{ cursor: "pointer", flexShrink: 0, color: "green" }}
                            />
                          ) : null}
                        </div>
                      );
                    },
                  },
                  {
                    key: "due_amount",
                    dataIndex: "due_amount",
                    title: "Balance Amount",
                    align: "end",
                    render: (val, record) => {
                      const isEditing = editingLoanId === record._id && editingField === "due_amount";
                      return (
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "flex-end",
                            alignItems: "center",
                            gap: "8px",
                          }}
                        >
                          {isEditing ? (
                            <InputNumber
                              controls={false}
                              prefix="$"
                              value={editValue ?? val}
                              onChange={(value) => setEditValue(value)}
                              style={{ width: "140px" }}
                              formatter={(value) => {
                                const [start, end] = `${value}`.split(".") || [];
                                const v = `${start}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                                return `${end ? `${v}.${end}` : `${v}`}`;
                              }}
                              parser={(value) => value?.replace(/\$\s?|(,*)/g, "") as unknown as number}
                            />
                          ) : (
                            <TextNumeric>{formatMoney(val)}</TextNumeric>
                          )}
                          {!isEditing ? (
                            <TbEdit
                              onClick={() => handleStartEdit(record._id, "due_amount", val)}
                              style={{ cursor: "pointer", flexShrink: 0 }}
                            />
                          ) : editValue !== val ? (
                            <TbCheck
                              onClick={() => handleSaveEdit(record)}
                              style={{ cursor: "pointer", flexShrink: 0, color: "green" }}
                            />
                          ) : null}
                        </div>
                      );
                    },
                  },
                  {
                    key: "payments",
                    dataIndex: "payments",
                    title: "Installation Payment",
                    align: "end",
                    render: (val, record) => (
                      <TextNumeric>{record?.payments ? formatMoney(record?.payments) : "-"}</TextNumeric>
                    ),
                  },
                  {
                    key: "funded_date",
                    dataIndex: "funded_date",
                    title: "Funded Date",
                    align: "center",
                    render: (val, record) => (
                      <TextNumeric>{record?.funded_date ? formatDate(record?.funded_date) : "-"}</TextNumeric>
                    ),
                  },
                  {
                    key: "frequency",
                    dataIndex: "frequency",
                    title: "Frequency",
                    width: 120,
                    render: (val, record) => {
                      return (
                        <div className="flex items-center gap-1">
                          <Typography.Text>{record?.frequency?.toUpperCase()}</Typography.Text>
                          {editUpstreamLoan.isPending && editUpstreamLoan.variables.loan._id === record._id ? (
                            <TbLoader2 size={16} className="animate-spin" />
                          ) : (
                            <Dropdown
                              menu={{
                                selectable: true,
                                selectedKeys: record.frequency ? [record.frequency] : [],

                                items: Object.values(FREQUENCY_TYPES).map((val, i) => {
                                  return {
                                    key: val,

                                    label: toTitleCase(val),
                                    onClick: () =>
                                      handleLoanFrequencyChange({
                                        prevFrequency: record.frequency as FREQUENCY_TYPES,
                                        newFrequency: val,
                                        record: record,
                                      }),
                                  };
                                }),
                              }}
                            >
                              <Button type="text" size="small" icon={<TbDotsVertical />} />
                            </Dropdown>
                          )}
                        </div>
                      );
                    },
                  },
                  {
                    key: "receivables",
                    dataIndex: "receivables",
                    title: "Receivables",
                    render: (val, record) => {
                      const isEditing = editingLoanId === record._id && editingField === "receivables";
                      return (
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "flex-start",
                            alignItems: "center",
                            gap: "8px",
                          }}
                        >
                          {isEditing ? (
                            <InputNumber
                              controls={false}
                              suffix="%"
                              value={editValue ?? val}
                              onChange={(value) => setEditValue(value)}
                              style={{ width: "100px" }}
                              min={0}
                              max={100}
                              formatter={(value) => {
                                const [start, end] = `${value}`.split(".") || [];
                                const v = `${start}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                                return `${end ? `${v}.${end}` : `${v}`}`;
                              }}
                              parser={(value) => value?.replace(/%\s?|(,*)/g, "") as unknown as number}
                            />
                          ) : record?.receivables ? (
                            <TextNumeric>{`${record?.receivables}%`}</TextNumeric>
                          ) : (
                            <span>-</span>
                          )}
                          {!isEditing ? (
                            <TbEdit
                              onClick={() => handleStartEdit(record._id, "receivables", val || 0)}
                              style={{ cursor: "pointer", flexShrink: 0 }}
                            />
                          ) : editValue !== val ? (
                            <TbCheck
                              onClick={() => handleSaveEdit(record)}
                              style={{ cursor: "pointer", flexShrink: 0, color: "green" }}
                            />
                          ) : null}
                        </div>
                      );
                    },
                  },
                  {
                    title: "Actions",
                    key: "actions",
                    render: (_, record) => {
                      const menuItems: ItemType[] = [
                        {
                          key: "link-creditor",
                          icon: <TbPlugConnected />,
                          label: "Link Creditor",
                          onClick: () => {
                            setSelectedLoan(record);
                            setOpenLinkCreditor(true);
                          },
                        },
                        {
                          key: "update-creditor",
                          icon: <TbRefresh />,
                          label: "Update Loan Details",
                          onClick: () => {
                            setFetchingLoanId(null);
                            setSelectedLoan(record);
                            setOpenCreditorModal(true);
                          },
                        },
                        // {
                        //   key: "upload-lawsuits",
                        //   icon: <TbUpload />,
                        //   label: "Upload Lawsuits",
                        //   onClick: () => {
                        //     setIsLawSuitsUploadModalOpen(true);
                        //     setSelectedLoan(record);
                        //   },
                        // },
                        {
                          key: "delete-lawsuits",
                          icon: <TbTrash />,
                          label: "Delete Loan",
                          onClick: () => {
                            //
                            Modal.confirm({
                              centered: true,
                              title: `Are you sure you want to delete ${record.creditor_name}?`,
                              content: "This action cannot be undone.",
                              okText: "Yes, Delete",
                              okButtonProps: { loading: deleteLoan.isPending },
                              okType: "danger",
                              cancelText: "No, Keep",
                              onOk: () => {
                                deleteLoan.mutate(
                                  { appkey: fetchedAppKey as string, loan_id: record._id },
                                  {
                                    onSuccess: () => {
                                      message.success("Loan deleted sucessfully.");
                                      queryClient.invalidateQueries({
                                        queryKey: ["application", appKey],
                                      });
                                    },
                                  },
                                );
                              },
                            });
                          },
                          danger: true,
                        },
                        // {
                        //   key: "navigate-creditor-logs",
                        //   icon: <TbTransactionDollar />,
                        //   label: "View Creditor Txn. Logs",
                        //   onClick: () => {
                        //     if (record.creditor_id) {
                        //       window.open(
                        //         `/dashboard/transaction-logs?creditor_id=${record.creditor_id}&wallet_type=${WalletTypes.CREDITOR}`,
                        //       );
                        //     } else {
                        //       message.error("Creditor ID not found. Link the creditor first.");
                        //     }
                        //   },
                        // },
                      ];
                      return (
                        <div className="flex items-center gap-1">
                          <Dropdown
                            menu={{
                              items: menuItems,
                            }}
                          >
                            <Button size="small" icon={<TbDotsVertical />} />
                          </Dropdown>
                          <Tooltip title="Upload Lawsuits">
                            <Button
                              size="small"
                              onClick={() => {
                                setIsLawSuitsUploadModalOpen(true);
                                setSelectedLoan(record);
                              }}
                              icon={<TbUpload />}
                            >
                              Lawsuits
                            </Button>
                          </Tooltip>
                        </div>
                      );
                    },
                  },
                ]}
                dataSource={getclearApplication?.loans}
                pagination={false}
                size="small"
                summary={(loans) => {
                  return (
                    <Table.Summary fixed={"bottom"}>
                      <Table.Summary.Row>
                        <Table.Summary.Cell index={0} className="bg-gray-100 font-bold text-gray-800">
                          Total
                        </Table.Summary.Cell>
                        <Table.Summary.Cell index={1} align="right" className="bg-gray-100 font-bold text-gray-800">
                          {loans
                            ? formatMoney(loans?.reduce((prev, curr) => prev + (curr?.funded_amount ?? 0), 0))
                            : "-"}
                        </Table.Summary.Cell>
                        <Table.Summary.Cell index={2} align="right" className="bg-gray-100 font-bold text-gray-800">
                          {loans
                            ? formatMoney(loans?.reduce((prev, curr) => prev + (curr?.payback_amount ?? 0), 0))
                            : "-"}
                        </Table.Summary.Cell>
                        <Table.Summary.Cell index={3} align="right" className="bg-gray-100 font-bold text-gray-800">
                          {loans ? formatMoney(loans?.reduce((prev, curr) => prev + (curr?.due_amount ?? 0), 0)) : "-"}
                        </Table.Summary.Cell>
                        <Table.Summary.Cell index={4} align="right" className="bg-gray-100 font-bold text-gray-800">
                          {loans
                            ? `${formatMoney(loans?.reduce((prev, curr) => prev + (curr?.payments ?? 0), 0))}/week`
                            : "-"}
                        </Table.Summary.Cell>
                        <Table.Summary.Cell
                          index={5}
                          align="right"
                          className="bg-gray-100 font-bold text-gray-800"
                        ></Table.Summary.Cell>
                        <Table.Summary.Cell
                          index={6}
                          align="right"
                          className="bg-gray-100 font-bold text-gray-800"
                        ></Table.Summary.Cell>
                      </Table.Summary.Row>
                    </Table.Summary>
                  );
                }}
              />
            </div>
            {/* {(getclearApplication?.loans ?? []).length > 0 &&
              getclearApplication?.lawsuits &&
              getclearApplication?.lawsuits?.length === 0 && (
                <Alert
                  message={"Use the three dot button in loan table to upload lawsuits for that particular loan"}
                  type="info"
                  showIcon
                />
              )} */}
            {getclearApplication?.lawsuits && getclearApplication?.lawsuits?.length ? (
              <div className="border border-solid border-gray-200 rounded-lg">
                <div className="flex items-center mb-3">
                  <Typography.Title level={5} className="mx-3 my-3">
                    Lawsuit Details
                  </Typography.Title>
                  <Badge color={"purple"} size="default" count={getclearApplication?.lawsuits?.length} />
                </div>
                <div className="grid grid-cols-12 gap-y-2 mx-3 mb-3">
                  {getclearApplication?.lawsuits?.map((lawsuit, i) => {
                    const loan = getclearApplication?.loans?.find((el) => el._id === lawsuit?.loan);
                    return (
                      <Fragment key={lawsuit._id}>
                        <div className="col-span-8">
                          <Typography.Text>{`${i + 1}. ${loan?.creditor_name} (${formatMoney(loan?.funded_amount)})`}</Typography.Text>
                        </div>
                        <div className="col-span-4 justify-self-end">
                          {lawsuit?.attachments?.length > 0 ? (
                            <ViewFileBanks attachments={lawsuit?.attachments} appKey={getclearApplication?.app_key} />
                          ) : null}
                        </div>
                      </Fragment>
                    );
                  })}
                </div>
              </div>
            ) : null}
            <div className="fixed z-20 p-4 border-0  bottom-0 right-0 flex justify-center mt-4">
              <Button
                size="large"
                loading={syncFinancialInfo.isPending}
                disabled={!allLoanOcrCompleted}
                onClick={() => {
                  if (getclearApplication?.loans.length === 0) {
                    message.error("Please add atleast one loan");
                    return;
                  }
                  if (!validateAllLoanFields()) {
                    return;
                  }

                  syncFinancialInfo.mutate(
                    { appKey: fetchedAppKey },
                    {
                      onSuccess: (data) => {
                        navigate(`/dashboard/application/strategy/${fetchedAppKey}`);
                      },
                    },
                  );
                }}
                iconPosition="end"
                icon={<TbChevronRight />}
                type="primary"
              >
                Continue
              </Button>
            </div>
          </div>
        ))}
      {step === 3 && (
        <div className="relative">
          {hasDetails === null && (
            <div className="z-20 absolute flex justify-center items-center w-full h-full bg-black/10">
              <div className="flex flex-col items-center">
                <TbLoader2 size={64} className="animate-spin stroke-purple-600" />
                {/* <Typography.Text>Please Wait..</Typography.Text> */}
              </div>
            </div>
          )}
          <Form
            onFinish={(values) => {
              console.log({ values });
            }}
            form={form}
            layout="vertical"
            initialValues={{
              summary: { lawsuit_insurance: true },
              client_details: { ...getclearApplication?.client_details },
              business_info: { ...getclearApplication?.business_info },
            }}
          >
            <div className="flex flex-col gap-8  mx-auto ">
              <div className="bg-white rounded-xl overflow-auto">
                <div className="flex justify-between items-center px-6 py-2  ">
                  <Typography.Title level={5} className="!m-0">
                    Business Information
                  </Typography.Title>

                  <Button
                    onClick={() => setIsCosignerModalOpen(true)}
                    icon={<TbUsers />}
                    variant="outlined"
                    color="primary"
                  >
                    Add Cosigner
                  </Button>
                </div>
                <div className="px-5">
                  <div className="grid grid-cols-12 gap-2">
                    <div className="col-span-4">
                      <Form.Item
                        name={["business_info", "company_name"]}
                        label="Company Name"
                        rules={[{ required: true }]}
                      >
                        <Input />
                      </Form.Item>
                    </div>
                    <div className="col-span-4">
                      <Form.Item
                        name={["business_info", "email"]}
                        label="Business Email"
                        rules={[{ required: true, type: "email" }]}
                      >
                        <Input inputMode="email" />
                      </Form.Item>
                    </div>
                    <div className="col-span-4">
                      <Form.Item name={["business_info", "phone"]} label="Business Phone" rules={[{ required: true }]}>
                        <InputNumber<string>
                          type="tel"
                          minLength={14}
                          maxLength={14}
                          style={{ width: "100%" }}
                          formatter={(value) => {
                            if (!value) return "";
                            const onlyNumbers = `${value}`.replace(/\D/g, "");
                            const formatted = onlyNumbers.replace(
                              /^(\d{0,3})(\d{0,3})(\d{0,4})$/,
                              (match, p1, p2, p3) => `${p1 ? `(${p1}) ` : ""}${p2 ? `${p2}` : ""}${p3 ? `-${p3}` : ""}`,
                            );
                            return formatted.trim();
                          }}
                          parser={(value) => value?.replace(/\D/g, "") as unknown as string}
                          controls={false}
                        />
                      </Form.Item>
                    </div>
                  </div>
                  <div className="grid grid-cols-12 gap-2">
                    <div className="col-span-4">
                      <Form.Item
                        name={["business_info", "business_type"]}
                        label="Business Type"
                        rules={[{ required: true }]}
                      >
                        <Select
                          options={[
                            "Corporation",
                            "Limited Liability Company",
                            "Partnership",
                            "Limited Partnership",
                            "Limited Liability Partnership",
                            "Sole Proprietorship",
                            "Other",
                          ].map((el) => ({ label: el, value: el }))}
                        />
                      </Form.Item>
                    </div>
                    <div className="col-span-4">
                      <Form.Item
                        name={["business_info", "ein_number"]}
                        label="EIN Number"
                        rules={[
                          { required: true, pattern: new RegExp(/^\d+$/), message: "Only digits are allowed" },
                          { len: 9, message: "EIN must be 9 digits" },
                        ]}
                      >
                        <Input maxLength={9} minLength={9} />
                      </Form.Item>
                    </div>
                    <div className="col-span-4">
                      <Form.Item
                        name={["client_details", "ssn"]}
                        label="Clients SSN"
                        rules={[
                          { required: true, pattern: new RegExp(/^\d+$/), message: "Only digits are allowed" },
                          { len: 9, message: "SSN must be 9 digits" },
                        ]}
                      >
                        <Input maxLength={9} minLength={9} />
                      </Form.Item>
                    </div>
                    {/* <div className="col-span-4">
                          <Form.Item
                            name={"business_type"}
                            label="Type of Business"
                            rules={[{ required: true }]}
                          >
                            <Input />
                          </Form.Item>
                        </div> */}
                  </div>

                  <Divider style={{ marginTop: 0, marginBottom: 14 }}></Divider>
                  <Form.Item
                    name={["business_info", "street_address"]}
                    label="Street Address"
                    rules={[{ required: true }]}
                  >
                    <Input />
                  </Form.Item>
                  <div className="grid grid-cols-12 gap-2">
                    <div className="col-span-4">
                      <Form.Item name={["business_info", "city"]} label="City" rules={[{ required: true }]}>
                        <Input />
                      </Form.Item>
                    </div>
                    <div className="col-span-4">
                      <Form.Item name={["business_info", "state"]} label="State" rules={[{ required: true }]}>
                        <AutoComplete
                          options={options}
                          style={{ width: "100%" }}
                          onBlur={() => setOptions(autoCompleteOption)}
                          onFocus={() => setOptions(autoCompleteOption)}
                          // onSelect={onSelect}
                          onSearch={(text) => {
                            setOptions(
                              autoCompleteOption.filter((option) => option.value.toLowerCase().startsWith(text)),
                            );
                          }}
                          placeholder="Search state here"
                        />
                      </Form.Item>
                    </div>

                    <div className="col-span-4">
                      <Form.Item name={["business_info", "zip_code"]} label="ZIP Code" rules={[{ required: true }]}>
                        <Input minLength={5} maxLength={5} />
                      </Form.Item>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <Modal open={isCosignerModalOpen} onCancel={() => setIsCosignerModalOpen(false)} width={600}>
              <div className="flex flex-col gap-8 max-w-[900px] mx-auto p-5">
                <div className="bg-white border border-solid border-gray-300 rounded-xl overflow-auto">
                  <Form.List name={["client_details", "cosigners"]}>
                    {(fields, { add, remove }) => (
                      <>
                        <div className="flex justify-between items-center px-6 py-4  border-[0] border-b bo      rder-solid border-gray-300 ">
                          <Typography.Title level={5} className="!text-sm !m-0">
                            Cosigner Details
                          </Typography.Title>
                          {fields.length === 0 ? (
                            <Button onClick={() => add()} icon={<TbPlus />}>
                              Add Cosigner
                            </Button>
                          ) : (
                            <Button onClick={() => remove(0)} icon={<TbMinus />}>
                              Remove Cosigner
                            </Button>
                          )}
                        </div>
                        <div className="p-5">
                          {fields.length === 0 ? (
                            <Empty description="Don't have cosigner" image={Empty.PRESENTED_IMAGE_DEFAULT} />
                          ) : null}
                          {fields.map(({ key, name, ...restField }) => (
                            <Fragment key={key}>
                              <Form.Item
                                {...restField}
                                label="Cosigner Name"
                                name={[name, "name"]}
                                rules={[{ required: true, message: "Missing cosigner name" }]}
                              >
                                <Input placeholder="Name" />
                              </Form.Item>
                              <Form.Item
                                {...restField}
                                label="Cosigner Email"
                                name={[name, "email"]}
                                rules={[
                                  { required: true, message: "Missing cosigner email" },
                                  { type: "email", message: "Invalid email" },
                                ]}
                              >
                                <Input placeholder="Email" />
                              </Form.Item>
                            </Fragment>
                          ))}
                        </div>
                      </>
                    )}
                  </Form.List>
                </div>
              </div>
            </Modal>

            <div className="flex flex-col gap-8 mx-auto  ">
              <div className="bg-white rounded-xl overflow-auto">
                <div className="flex justify-between items-center px-6 py-4 ">
                  <Typography.Title level={5} className="!m-0">
                    Payment Information
                  </Typography.Title>
                </div>
                <div className="px-5">
                  <div className="grid grid-cols-12 gap-2">
                    <div className="col-span-3">
                      <Form.Item name={["selected_bank", "bank_name"]} label="Bank Name" rules={[{ required: true }]}>
                        <Input style={{ width: "100%" }} />
                      </Form.Item>
                    </div>
                    <div className="col-span-3">
                      <Form.Item
                        name={["selected_bank", "name_on_account"]}
                        label="Name on account"
                        rules={[{ required: true }]}
                      >
                        <Input />
                      </Form.Item>
                    </div>
                    <div className="col-span-3">
                      <Form.Item name={["selected_bank", "routing_no"]} label="Routing No" rules={[{ required: true }]}>
                        <Input maxLength={9} minLength={9} />
                      </Form.Item>
                    </div>
                    <div className="col-span-3">
                      <Form.Item name={["selected_bank", "account_no"]} label="Account No" rules={[{ required: true }]}>
                        <Input style={{ width: "100%" }} />
                      </Form.Item>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="flex flex-col gap-8 mx-auto  ">
              <div className="bg-white rounded-xl overflow-auto">
                <div className="flex justify-between items-center px-6 py-4  ">
                  <Typography.Title level={5} className="!m-0">
                    Financial Summary
                  </Typography.Title>
                </div>
                <div className="px-5 py-2">
                  <div className="grid grid-cols-12 gap-2">
                    <div className="col-span-3">
                      <Form.Item
                        name={["summary", "current_debt"]}
                        label="Current Total Debt"
                        rules={[
                          { type: "number", min: 0, message: "Total debt is not a valid amount", required: true },
                        ]}
                      >
                        <InputNumber controls={false} suffix={"$"} style={{ width: "100%" }} />
                      </Form.Item>
                    </div>
                    <div className="col-span-3">
                      <Form.Item
                        name={["summary", "weekly_budget"]}
                        label="Weekly Budget"
                        rules={[{ type: "number", min: 0, message: "Weekly budget is not a valid amount" }]}
                      >
                        <InputNumber controls={false} suffix={"$"} style={{ width: "100%" }} />
                      </Form.Item>
                    </div>
                    <div className="col-span-3">
                      <Form.Item
                        name={["summary", "weekly_payments"]}
                        label="Current Weekly Payments"
                        rules={[
                          {
                            type: "number",
                            min: 0,
                            message: "Current weekly payments is not a valid amount",
                            required: true,
                          },
                        ]}
                      >
                        <InputNumber controls={false} suffix={"$"} style={{ width: "100%" }} />
                      </Form.Item>
                    </div>
                    <div className="col-span-3">
                      <Form.Item
                        name={["summary", "monthly_revenue"]}
                        label="Monthly Revenue"
                        rules={[
                          {
                            type: "number",

                            message: "Monthly revenue is not a valid amount",
                            required: mode === "percentage",
                          },
                        ]}
                      >
                        <InputNumber min={0} controls={false} suffix={"$"} style={{ width: "100%" }} />
                      </Form.Item>
                    </div>
                  </div>
                  {/* <div className="grid grid-cols-12 gap-2">
                
              </div> */}
                  <div className="grid grid-cols-12 gap-2">
                    <div className="col-span-4">
                      <Form.Item
                        name={["summary", "profit_percentage"]}
                        label="Profit Percentage"
                        rules={[
                          {
                            type: "number",

                            message: "Profit percentage is not a valid amount",
                            required: mode === "percentage",
                          },
                        ]}
                      >
                        <InputNumber min={0} max={100} controls={false} suffix={"%"} style={{ width: "100%" }} />
                      </Form.Item>
                    </div>
                    <div className="col-span-4">
                      <Form.Item
                        name={["summary", "total_advance_amount"]}
                        label="Advanced Amount (If Any)"
                        rules={[{ type: "number", min: 0, message: "Advanced amount is not a valid amount" }]}
                      >
                        <InputNumber controls={false} suffix={"$"} style={{ width: "100%" }} />
                      </Form.Item>
                    </div>
                    <div className="col-span-4">
                      <Form.Item
                        name={["summary", "lawsuit_insurance"]}
                        label="Do you have lawsuit insurance?"
                        rules={[{ type: "boolean", message: "Lawsuit insurance must be true or false" }]}
                        valuePropName="checked"
                      >
                        <Checkbox>Apply Lawsuit Insurance</Checkbox>
                      </Form.Item>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </Form>
          <div className=" mx-auto p-5">
            <Button
              loading={editMetaInfo.isPending}
              onClick={async () => {
                const values = await form.validateFields();

                editMetaInfo.mutate(
                  {
                    appkey: fetchedAppKey as string,
                    business_info: values.business_info,
                    client_details: {
                      ...values.client_details,
                      name: nameFromParams,
                      phone: phoneFromParams ?? undefined,
                    },
                    selected_bank: values.selected_bank,
                    summary: values.summary,
                  },
                  {
                    onSuccess: async () => {
                      message.success(`Meta information edited succesfully!`);
                      await syncBalance.mutateAsync({
                        appkey: fetchedAppKey as string,
                      });
                      if (mode === "percentage") {
                        setStrategyModalOpen(true);
                        form.resetFields();
                      } else {
                        form.resetFields();
                        queryClient.invalidateQueries({ queryKey: ["application", appKey] });
                        navigate("/dashboard/application/" + fetchedAppKey);
                      }
                    },
                  },
                );
              }}
              block
              icon={<TbRefresh />}
              type="primary"
            >
              Update Details
            </Button>
          </div>
        </div>
      )}
      {/* <Modal
        title="Link Creditor"
        open={openLinkCreditor}
        onCancel={() => {
          linkCreditorForm.resetFields();
          setSelectedLoan(undefined);
          setOpenLinkCreditor(false);
        }}
        width={520}
        footer={[
          <Button
            key="cancel"
            onClick={() => {
              linkCreditorForm.resetFields();
              setSelectedLoan(undefined);
              setOpenLinkCreditor(false);
            }}
          >
            Cancel
          </Button>,
          <Button key="submit" type="primary" onClick={() => linkCreditorForm.submit()}>
            Link Creditor
          </Button>,
        ]}
      >
        <Form
          form={linkCreditorForm}
          layout="vertical"
          initialValues={{
            creditor_id: selectedLoan?.creditor_id,
          }}
          onFinish={(values) => {
            linkCreditor.mutate(
              { loan_id: selectedLoan?._id ?? "", creditor_id: values.creditor_id },
              {
                onSuccess: () => {
                  message.success(`Creditor linked succesfully.`);
                  fullApplication.refetch();
                  setSelectedLoan(undefined);
                  setOpenLinkCreditor(false);
                },
              },
            );
          }}
        >
          <div className="flex flex-col gap-6">
            <div className="rounded-lg border border-gray-200 bg-gray-50 px-4 py-3">
              <div className="flex items-start justify-between gap-3 mb-1">
                <div className="text-xs font-medium uppercase tracking-wide text-gray-500">Provided Creditor Name</div>

                <Tag
                  className="!m-0 px-2 py-0.5 text-xs font-medium capitalize"
                  color={
                    selectedLoan?.creditor_match === CreditorMatchSync.MATCHED
                      ? "green"
                      : selectedLoan?.creditor_match === CreditorMatchSync.PROBABLE
                        ? "yellow"
                        : "red"
                  }
                >
                  {selectedLoan?.creditor_match
                    ? `${selectedLoan.creditor_match.toUpperCase()} ${selectedLoan?.creditor_match === CreditorMatchSync.MATCHED ? "" : "MATCH"}`
                    : "NOT LINKED"}
                </Tag>
              </div>

              <div className="text-base font-semibold text-gray-900">{selectedLoan?.creditor_name || "-"}</div>
            </div>

            <div className="rounded-lg border border-gray-200 bg-gray-50 px-4 py-3">
              <div className="flex items-center justify-between mb-2">
                <div className="text-sm font-medium text-gray-500">POTENTIAL MATCHES</div>
                <Button size="small" icon={<TbReload />} type="primary" onClick={() => allCreditors.refetch()}>
                  Refetch
                </Button>
              </div>

              <div className="text-sm text-gray-800 leading-relaxed">
                {(() => {
                  const matches = fuzzyMatch(
                    creditorNames.map((c) => c.name),
                    selectedLoan?.creditor_name ?? "",
                  );

                  if (!matches || matches.length === 0) {
                    return <span className="text-gray-400">No close matches found</span>;
                  }

                  return matches.slice(0, 5).map((name) => (
                    <div key={name} className="flex items-center justify-between gap-2 py-1">
                      <span className="font-medium truncate">{name}</span>

                      <TbArrowsExchange
                        size={14}
                        className="cursor-pointer text-purple-600 hover:text-purple-800"
                        onClick={() => {
                          const creditorId = creditorNames.find((c) => c.name === name)?.id;

                          if (!creditorId) {
                            message.warning("Creditor not found in list");
                            return;
                          }

                          linkCreditorForm.setFieldsValue({
                            creditor_id: creditorId,
                          });

                          message.success(`Selected "${name}"`);
                        }}
                      />
                    </div>
                  ));
                })()}
              </div>
            </div>

            <Form.Item
              name="creditor_id"
              label="Link to existing creditor"
              rules={[{ required: true, message: "Select a creditor" }]}
            >
              <Select
                showSearch
                allowClear
                optionFilterProp="label"
                placeholder="Search or create creditor"
                onSearch={(value) => setNewCreditorName(value)}
                options={allCreditorsData.map((c) => ({
                  label: c.name,
                  value: c._id,
                }))}
                dropdownRender={(menu) => (
                  <>
                    {menu}

                    {newCreditorName &&
                      !allCreditorsData.some((c) => c.name.toLowerCase() === newCreditorName.toLowerCase()) && (
                        <div className="border-t border-gray-200 px-3 py-2">
                          <Button
                            type="text"
                            className="w-full text-left text-purple-600"
                            icon={<TbPlus size={14} />}
                            onClick={async () => {
                              addCreditor.mutate(
                                {
                                  dto: {
                                    name: newCreditorName,
                                    allowed_domains: [],
                                    allowed_emails: [],
                                    allowed_phones: [],
                                    alternate_names: [],
                                    slug: "",
                                    inDraft: false,
                                  },
                                  bypass: false,
                                },
                                {
                                  onSuccess: (created) => {
                                    message.success(`Creditor created`);

                                    allCreditors.refetch();

                                    linkCreditorForm.setFieldsValue({
                                      creditor_id: created.result._id,
                                    });

                                    setNewCreditorName("");
                                  },
                                },
                              );
                            }}
                          >
                            {`Create creditor “${newCreditorName}”`}
                          </Button>
                        </div>
                      )}
                  </>
                )}
              />
            </Form.Item>
          </div>
        </Form>
      </Modal> */}
      <Modal
        title="Link Creditor"
        open={openLinkCreditor}
        onCancel={() => {
          linkCreditorForm.resetFields();
          setSelectedLoan(undefined);
          setOpenLinkCreditor(false);
        }}
        width={520}
        footer={[
          <Button
            key="cancel"
            onClick={() => {
              linkCreditorForm.resetFields();
              setSelectedLoan(undefined);
              setOpenLinkCreditor(false);
            }}
          >
            Cancel
          </Button>,
          <Button key="submit" type="primary" onClick={() => linkCreditorForm.submit()}>
            Link Creditor
          </Button>,
        ]}
      >
        <Form
          form={linkCreditorForm}
          layout="vertical"
          initialValues={{
            creditor_id: selectedLoan?.creditor_id,
            partner_creditor_id: selectedLoan?.partner_creditor_id,
          }}
          onFinish={(values) => {
            linkCreditor.mutate(
              {
                loan_id: selectedLoan?._id ?? "",
                creditor_id: values.creditor_id,
                partner_creditor_id: values.partner_creditor_id,
              },
              {
                onSuccess: () => {
                  message.success(`Creditor linked succesfully.`);
                  fullApplication.refetch();
                  setSelectedLoan(undefined);
                  setOpenLinkCreditor(false);
                },
              },
            );
          }}
        >
          <div className="flex flex-col gap-6">
            <div className="rounded-lg border border-gray-200 bg-gray-50 px-4 py-3">
              <div className="flex items-start justify-between gap-3 mb-1">
                <div className="text-xs font-medium uppercase tracking-wide text-gray-500">Provided Creditor Name</div>

                <Tag
                  className="!m-0 px-2 py-0.5 text-xs font-medium capitalize"
                  color={
                    selectedLoan?.creditor_match === CreditorMatchSync.MATCHED
                      ? "green"
                      : selectedLoan?.creditor_match === CreditorMatchSync.PROBABLE
                        ? "yellow"
                        : "red"
                  }
                >
                  {selectedLoan?.creditor_match
                    ? `${selectedLoan.creditor_match.toUpperCase()} ${selectedLoan?.creditor_match === CreditorMatchSync.MATCHED ? "" : "MATCH"}`
                    : "NOT LINKED"}
                </Tag>
              </div>

              <div className="text-base font-semibold text-gray-900">{selectedLoan?.creditor_name || "-"}</div>
            </div>

            <div className="rounded-lg border border-gray-200 bg-gray-50 px-4 py-3">
              <div className="flex items-center justify-between mb-2">
                <div className="text-sm font-medium text-gray-500">POTENTIAL MATCHES</div>
                <Button size="small" icon={<TbReload />} type="primary" onClick={() => allCreditors.refetch()}>
                  Refetch
                </Button>
              </div>

              <div className="text-sm text-gray-800 leading-relaxed">
                {(() => {
                  const matches = fuzzyMatch(
                    creditorNames.filter((c) => c.isPartner === false).map((c) => c.name),
                    selectedLoan?.creditor_name ?? "",
                  );

                  if (!matches || matches.length === 0) {
                    return <span className="text-gray-400">No close matches found</span>;
                  }

                  return matches.slice(0, 5).map((name) => (
                    <div key={name} className="flex items-center justify-between gap-2 py-1">
                      <span className="font-medium truncate">{name}</span>

                      <TbArrowsExchange
                        size={14}
                        className="cursor-pointer text-purple-600 hover:text-purple-800"
                        onClick={() => {
                          const creditorId = creditorNames.find((c) => c.name === name)?.id;

                          if (!creditorId) {
                            message.warning("Creditor not found in list");
                            return;
                          }

                          linkCreditorForm.setFieldsValue({
                            creditor_id: creditorId,
                          });

                          message.success(`Selected "${name}"`);
                        }}
                      />
                    </div>
                  ));
                })()}
              </div>
            </div>

            <Form.Item
              name="creditor_id"
              label="Link to existing creditor"
              rules={[{ required: true, message: "Select a creditor" }]}
            >
              <Select
                showSearch
                allowClear
                optionFilterProp="label"
                placeholder="Search or create creditor"
                onSearch={(value) => setNewCreditorName(value)}
                options={allCreditorsData
                  .filter((c) => !c.isPartner)
                  .map((c) => ({
                    label: c.name,
                    value: c._id,
                  }))}
                dropdownRender={(menu) => (
                  <>
                    {menu}

                    {newCreditorName &&
                      !allCreditorsData.some(
                        (c) => c.name.toLowerCase() === newCreditorName.toLowerCase() && !c.isPartner,
                      ) && (
                        <div className="border-t border-gray-200 px-3 py-2">
                          <Button
                            type="text"
                            className="w-full text-left text-purple-600"
                            icon={<TbPlus size={14} />}
                            onClick={async () => {
                              addCreditor.mutate(
                                {
                                  dto: {
                                    name: newCreditorName,
                                    allowed_domains: [],
                                    allowed_emails: [],
                                    allowed_phones: [],
                                    alternate_names: [],
                                    slug: "",
                                    inDraft: false,
                                  },
                                  bypass: false,
                                },
                                {
                                  onSuccess: (created) => {
                                    message.success(`Creditor created`);

                                    allCreditors.refetch();

                                    linkCreditorForm.setFieldsValue({
                                      creditor_id: created.result._id,
                                    });

                                    setNewCreditorName("");
                                  },
                                },
                              );
                            }}
                          >
                            {`Create creditor “${newCreditorName}”`}
                          </Button>
                        </div>
                      )}
                  </>
                )}
              />
            </Form.Item>

            <Form.Item name="partner_creditor_id" label="Link to existing partner creditor">
              <Select
                showSearch
                allowClear
                optionFilterProp="label"
                placeholder="Search or create partner creditor"
                onSearch={(value) => setNewPartnerCreditorName(value)}
                options={allCreditorsData
                  .filter((c) => c.isPartner === true)
                  .map((c) => ({
                    label: c.name,
                    value: c._id,
                  }))}
                dropdownRender={(menu) => (
                  <>
                    {menu}

                    {newPartnerCreditorName &&
                      !allCreditorsData.some(
                        (c) => c.name.toLowerCase() === newPartnerCreditorName.toLowerCase() && c.isPartner === true,
                      ) && (
                        <div className="border-t border-gray-200 px-3 py-2">
                          <Button
                            type="text"
                            className="w-full text-left text-purple-600"
                            icon={<TbPlus size={14} />}
                            onClick={async () => {
                              addCreditor.mutate(
                                {
                                  dto: {
                                    name: newPartnerCreditorName,
                                    allowed_domains: [],
                                    allowed_emails: [],
                                    allowed_phones: [],
                                    alternate_names: [],
                                    slug: "",
                                    inDraft: false,
                                    isPartner: true,
                                  },
                                  bypass: false,
                                },
                                {
                                  onSuccess: (created) => {
                                    message.success(`Partner creditor created`);

                                    allCreditors.refetch();

                                    linkCreditorForm.setFieldsValue({
                                      partner_creditor_id: created.result._id,
                                    });

                                    setNewPartnerCreditorName("");
                                  },
                                },
                              );
                            }}
                          >
                            {`Create partner creditor “${newPartnerCreditorName}”`}
                          </Button>
                        </div>
                      )}
                  </>
                )}
              />
            </Form.Item>
          </div>
        </Form>
      </Modal>
      <CreditorModal
        appkey={fetchedAppKey!}
        selectedLoan={selectedLoan}
        open={openCreditorModal}
        onClose={() => setOpenCreditorModal(false)}
        source="create-application"
      />
      <UploadLoanModal
        isOpen={isLoanUploadModalOpen}
        onClose={() => setIsLoanUploadModalOpen(false)}
        uploadType={uploadType}
        appkey={fetchedAppKey!}
      />
      <UploadLawSuitsModal
        appkey={appKey!}
        loanDetails={selectedLoan}
        isOpen={isLawSuitsUploadModalOpen}
        onClose={() => {
          setIsLawSuitsUploadModalOpen(false);
          setSelectedLoan(undefined);
        }}
      />
      <StrategyConfigModal isOpen={strategyModalOpen} appKey={fetchedAppKey} />
    </DashboardLayout>
  );
};

export default CreateApplication;
